// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFoundBlock_wrapper__IFj9b"};